'use client';

export { UserAvatar } from './UserAvatar';
